<template>
	<div
		:class="[
			'text-gray-700 focus-within:text-orange-500',
			markInvalid ? 'text-red-500' : '',
		]"
	>
		<div class="flex justify-between flex-wrap">
			<label class="block font-medium" :for="inputId" v-if="!noLabel">{{
				__(label)
			}}</label>
			<span class="text-red-500" v-if="markInvalid">{{
				validationMessage
			}}</span>
			<span class="text-gray-500" v-else-if="!required">optional</span>
		</div>
		<div class="mt-1 relative">
			<select
				:id="inputId"
				:class="[
					'text-gray-900 shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full border-gray-300 rounded-md',
					markInvalid
						? 'text-red-500 border-red-500 shadow-sm focus:text-gray-900'
						: '',
				]"
				v-model="val"
			>
				<option v-if="!required || !val"></option>
				<option v-for="o in options" :key="o.id" :value="o.id">
					{{ __(o.name || o.label) }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
import UiInputGroup from "./InputGroup.vue";
export default {
	mixins: [UiInputGroup],
	props: {
		type: {
			type: String,
			default: "select",
		},
		options: {
			type: Array,
			required: true,
		},
		noLabel: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
